import { render, staticRenderFns } from "./qwServiceStaff.vue?vue&type=template&id=23e6a989&scoped=true&"
import script from "./qwServiceStaff.vue?vue&type=script&lang=js&"
export * from "./qwServiceStaff.vue?vue&type=script&lang=js&"
import style0 from "./qwServiceStaff.vue?vue&type=style&index=0&id=23e6a989&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e6a989",
  null
  
)

export default component.exports